<template>
  <BasePage :filters="filters" :disable-count="pageCount">
    <slot name="banner"></slot>
    <div class="analysis-section">
      <div class="heading">
        <slot name="header"></slot>
      </div>
      <div class="analysis-table">
        <slot name="body"></slot>
      </div>
    </div>
  </BasePage>
</template>

<script>
import BasePage from '@/components/Report/BasePage';
export default {
  components: {
    BasePage,
  },

  props: ['filters', 'pageCount'],
};
</script>

<style lang="scss" scoped>
@use '@/styles/A4.scss';
.page {
  width: 297mm;
  height: 209mm;
  background-color: white;
  box-sizing: border-box;
  page-break-after: always;
  display: flex;
  flex-direction: column;

  // transform: scale(0.5);
  // margin: -320px auto;

  margin: 64px auto;
  border-radius: 4px;
  overflow: hidden;
  box-shadow:
    0 4px 24px 0 rgba(0, 0, 0, 0.1),
    0 4px 8px -4px rgba(0, 0, 0, 0.4);

  .analysis-section {
    flex: 1;
    padding-left: 65px * A4.$ratio;
    padding-right: 65px * A4.$ratio;
  }
  .heading {
    flex-direction: column;
    align-items: flex-start;
    padding-top: 20px * A4.$ratio;
    padding-bottom: 16px * A4.$ratio;
  }
}

@media print {
  .page {
    transform: scale(1);
    margin: 0;
    border-radius: 0;
    box-shadow: none;
  }
}
</style>
